import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITableScriptExecuteBehavior } from "../../../../documaker/domain/format/objects";

export interface ITableScriptExecuteBehaviorPropertyEditable {
  tableScriptExecuteBehavior(): IPropertyEditable<ITableScriptExecuteBehavior>;
}

export function instanceOfITableScriptExecuteBehaviorPropertyEditable(instance: any): instance is ITableScriptExecuteBehaviorPropertyEditable {
  return instance
      && instance.tableScriptExecuteBehavior
      && instanceOfIPropertyEditable<ITableScriptExecuteBehavior>(instance.tableScriptExecuteBehavior());
}
